import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ServiceOffert = lazy(() => import("@/pages/offert/ServiceOffert"));

export const Route = createFileRoute("/hembatterier/offert")({
  head: () => seoHead("/hembatterier/offert"),
  component: () => <ServiceOffert service="hembatterier" />,
});
